import { Component } from '@angular/core';
import { BackgroundVerificationService } from '../../../Model/BackgroundVerification/background-verification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ApprovalMatrixFormFilterComponent } from '../../ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';

@Component({
  selector: 'app-background-verification-policy-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbTooltip, LoaderComponent],
  templateUrl: './background-verification-policy-form.component.html',
  styleUrl: './background-verification-policy-form.component.scss'
})
export class BackgroundVerificationPolicyFormComponent {
  isDisabled: boolean = false;
  isPageDisabled: boolean = true;
  LastWebESSApplicabilityId = null;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  Applicabilitys = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;
  BackgroundVerificationDetail = {
    SelectType: 'insert',
    ESS_bgvPolicyID: 0,
    PolicyName: null,
    DefaultPolicy: false,
    ess_bgvApiMasterId: null,
    ESS_bgvPolicyDetails: [] as any,
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
    EmpType: 'FRONT'
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  Vendors = [] as any;
  CheckLists = [] as any;

  constructor(
    private toast: ToastService,
    private session: SessionService,
    private approvalMatrix: ApprovalMatrixService,
    private backgroundVerification: BackgroundVerificationService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    protected common: CommonService,
    protected tooltip: TooltipService,
    private combo: ComboService,
  ) {
    //this.common.getPageRights();
    this.common.PageRight.IsView = true;
    this.common.PageRight.IsAdd = true;
    this.common.PageRight.IsEdit = true;
    this.route.params.subscribe(params => this.BackgroundVerificationDetail.ESS_bgvPolicyID = parseInt(params['id']));
  }

  ngOnInit(): void {
    this.ESS_BGVFillCombo('API');
    if (this.BackgroundVerificationDetail.ESS_bgvPolicyID > 0) {
      this.ESS_bgvPolicyLoad();
    } else {
      this.GetApplicability();
    }
  }

  ngAfterViewInit() {
    this.isPageDisabled = false;
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_bgvPolicyInsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'BGV', WebESSApplicabilityMasterID: 0, EmpType: this.BackgroundVerificationDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (response.Table.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0) >= 0) {
          this.Applicabilitys.push(response.Table.filter((e: any) => e.WebESSApplicabilityMasterID == 0)[0]);
          this.Applicabilitys.splice(this.Applicabilitys.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0), 1);
        }
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.BackgroundVerificationDetail.WebESSApplicabilityId).length == 0) {
          this.BackgroundVerificationDetail.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.BackgroundVerificationDetail.WebESSApplicabilityId == 3 || this.BackgroundVerificationDetail.WebESSApplicabilityId == 4 || this.BackgroundVerificationDetail.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.RegularizationRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.BackgroundVerificationDetail.MappedId = null;
        this.LastWebESSApplicabilityId = this.BackgroundVerificationDetail.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.BackgroundVerificationDetail.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.BackgroundVerificationDetail.WebESSApplicabilityId == 3 ? 'Client' : this.BackgroundVerificationDetail.WebESSApplicabilityId == 4 ? 'Site' : this.BackgroundVerificationDetail.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.BackgroundVerificationDetail.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.BackgroundVerificationDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.BackgroundVerificationDetail.WebESSApplicabilityId == 3 || this.BackgroundVerificationDetail.WebESSApplicabilityId == 4 || this.BackgroundVerificationDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.BackgroundVerificationDetail.WebESSApplicabilityId == 4 || this.BackgroundVerificationDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.BackgroundVerificationDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.BackgroundVerificationDetail.WebESSApplicabilityId == 8 || this.BackgroundVerificationDetail.WebESSApplicabilityId == 4) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 4) {
        if (result.length >= 0) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteCode + '-' + element.SiteName,
                  WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                  IsCheck: true,
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else {
          this.ApprovalComboLoad('Site');
        }
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                  IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                  IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                IsCheck: this.BackgroundVerificationDetail.MappedId != null ? this.BackgroundVerificationDetail.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.BackgroundVerificationDetail.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.BackgroundVerificationDetail.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  ESS_BGVFillCombo(SelectType: string) {
    if (SelectType == 'API') {
      this.Vendors = [];
    } else if (SelectType == 'S') {
      this.CheckLists = [];
    }

    this.isDisabled = true;
    this.backgroundVerification.ESS_BGVFillCombo({ SelectType: SelectType, ESS_BGVCheckListMasterID: 0, ESS_BGVApiMasterID: this.BackgroundVerificationDetail.ess_bgvApiMasterId }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (SelectType == 'API') {
            this.Vendors = response.Table;
          } else if (SelectType == 'S') {
            this.CheckLists = response.Table;

            this.BackgroundVerificationDetail.ESS_bgvPolicyDetails.forEach((element: any) => {
              const index = this.CheckLists.findIndex((e: any) => e.ESS_BGVCheckListMasterID == element.ESS_BGVCheckListMasterId);
              if (index >= 0) {
                this.CheckLists[index].IsMandatory = element.IsMandatory;
                this.CheckLists[index].IsVerification = element.IsVerification;
                this.CheckLists[index].PolicyInitiationDays = element.PolicyInitiationDays;
              }
            });
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onVendorChange() {
    this.ESS_BGVFillCombo('S');
  }

  ESS_bgvPolicyLoad() {
    this.isDisabled = true;
    this.backgroundVerification.ESS_bgvPolicyLoad({ SelectType: 1, ESS_bgvPolicyID: this.BackgroundVerificationDetail.ESS_bgvPolicyID }).subscribe({
      next: (response) => {
        if (response.Table && response.Table.length > 0) {
          this.BackgroundVerificationDetail.SelectType = 'update';
          this.BackgroundVerificationDetail.ESS_bgvPolicyID = response.Table[0].ESS_bgvPolicyId;
          this.BackgroundVerificationDetail.PolicyName = response.Table[0].PolicyName;
          this.BackgroundVerificationDetail.DefaultPolicy = response.Table[0].DefaultPolicy;
          this.BackgroundVerificationDetail.ess_bgvApiMasterId = response.Table[0].ess_bgvApiMasterId;
          this.BackgroundVerificationDetail.WebESSApplicabilityId = response.Table[0].WebESSApplicabilityId;
          this.BackgroundVerificationDetail.EmpType = response.Table[0].EmpType;
          this.BackgroundVerificationDetail.MappedId = response.Table3.map((e: any) => e.MappedId).toString();
          this.BackgroundVerificationDetail.ESS_bgvPolicyDetails = response.Table1;

          if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 1) {
            this.ApprovalComboLoad('Company');
          } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 2) {
            this.ApprovalComboLoad('Branch');
          } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 3) {
            //this.ApprovalComboLoad('Client');
            response.Table3.forEach((element: any) => {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.MappedId,
                  ApplicabilityData: element.MappedValue,
                  WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            });
            this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
          } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 4) {
            //this.ApprovalComboLoad('Site');
            response.Table3.forEach((element: any) => {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.MappedId,
                  ApplicabilityData: element.MappedValue,
                  WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            });
            this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
          } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 5) {
            this.ApprovalComboLoad('Department');
          } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 6) {
            this.ApprovalComboLoad('Designation');
          } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 7) {
            this.ApprovalComboLoad('User');
          } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 8) {
            // response.Table2.map((e: any) => e.MappedId).forEach((element: any) => {
            //   this.ComboLoad('EmpLoadOnId', element);
            // });
            response.Table3.forEach((element: any) => {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.MappedId,
                  ApplicabilityData: element.MappedValue,
                  WebESSApplicabilityId: this.BackgroundVerificationDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            });
            this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
          } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 9) {
            this.ApprovalComboLoad('Grade');
          }
          if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 8) {
            this.GetApplicability(false);
          } else {
            this.GetApplicability();
          }

          this.onVendorChange();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_bgvPolicyInsertUpdate() {
    //await this.common.getPageRights();
    this.SearchDropdown('', 'Applicability');
    if (this.CheckLists.length <= 0 || this.CheckLists.filter((e: any) => e.IsVerification).length <= 0) {
      this.toast.show({ message: 'Please check atleast one check point', type: toastTypeEnum.warning });
    } else if (this.BackgroundVerificationDetail.EmpType != 'FRONT' && this.BackgroundVerificationDetail.EmpType != 'BACK') {
      this.toast.show({ message: 'Please select applicable for', type: toastTypeEnum.warning });
    } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == null) {
      this.toast.show({ message: 'Please select applicability', type: toastTypeEnum.warning });
    } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: 'Please select sub applicability', type: toastTypeEnum.warning });
    } else if (this.BackgroundVerificationDetail.WebESSApplicabilityId == 0 && this.BackgroundVerificationDetail.DefaultPolicy) {
      this.toast.show({ message: "Applicability none not allow for default rule yes", type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.BackgroundVerificationDetail.ESS_bgvPolicyID == 0) || (this.common.PageRight.IsEdit && this.BackgroundVerificationDetail.ESS_bgvPolicyID > 0)) {
          if (result) {
            this.isDisabled = true;

            this.BackgroundVerificationDetail.ESS_bgvPolicyDetails = [];
            this.CheckLists.filter((e: any) => e.IsVerification).forEach((element: any) => {
              this.BackgroundVerificationDetail.ESS_bgvPolicyDetails.push(
                {
                  ESS_BGVCheckListMasterId: element.ESS_BGVCheckListMasterID,
                  IsMandatory: element.IsMandatory ?? false,
                  IsVerification: element.IsVerification,
                  InitiationDays: element.InitiationDays,
                }
              );
            });

            this.BackgroundVerificationDetail.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.BackgroundVerificationDetail.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString();
            this.backgroundVerification.ESS_bgvPolicyInsertUpdate(this.BackgroundVerificationDetail).subscribe({
              next: (response) => {
                if (response.Error_Code == "01") {
                  this.close();
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      });
    }
  }

  MandatoryCheck(event: any, index: number) {
    const isChecked = event.target.checked;
    if (isChecked) {
      this.CheckLists[index].IsVerification = true;
    }
  }

  VerificationCheck(event: any, index: number) {
    const isChecked = event.target.checked;
    if (!isChecked) {
      this.CheckLists[index].IsMandatory = false;
    }
  }

  close() {
    this.router.navigate(['/setting/bgvpolicies/']);
  }
}
